import { Box } from '@chakra-ui/react'

const ImageLogo = ({ as, src, alt, w, h, p, display, isDark }) => {
  return (
    <Box
      as={as}
      display={display}
      p={p || 3}
      rounded='md'
      bg={isDark ? 'black' : 'white'}
    >
      <img alt={alt} src={src} style={{ height: h, width: w }} />
    </Box>
  )
}

export default ImageLogo
